<template>
  <div class="countdown-container">
    <div class="countdown-timer font-family-1 f-w-600">
      {{ formattedCountdown }}
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from "vue";

// State
const countdown = ref({
  days: 0,
  hours: 0,
  minutes: 0,
  seconds: 0,
});

let timerInterval = null;

// Computed
const formattedCountdown = computed(() => {
  const { days, hours, minutes, seconds } = countdown.value;

  // Format each value with leading zeros
  const formattedDays = String(days).padStart(2, "0");
  const formattedHours = String(hours).padStart(2, "0");
  const formattedMinutes = String(minutes).padStart(2, "0");
  const formattedSeconds = String(seconds).padStart(2, "0");

  // Include days in the display if more than 0 days remain
  if (days > 0) {
    return `${formattedDays} : ${formattedHours} : ${formattedMinutes} : ${formattedSeconds}`;
  } else {
    return `${formattedHours} : ${formattedMinutes} : ${formattedSeconds}`;
  }
});

// Methods
const calculateTimeToFriday = () => {
  const now = new Date();
  const fridayDay = 5;

  let currentDay = now.getDay();

  // Days until next Friday
  let daysUntilFriday = fridayDay - currentDay;
  if (daysUntilFriday < 0 || (daysUntilFriday === 0 && now.getHours() >= 8)) {
    daysUntilFriday += 7;
  }

  const nextFriday = new Date(now);
  nextFriday.setDate(now.getDate() + daysUntilFriday);
  nextFriday.setHours(7, 0, 0, 0); // Set time to 08:00 AM

  let diff = nextFriday - now;

  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  diff -= days * (1000 * 60 * 60 * 24);

  const hours = Math.floor(diff / (1000 * 60 * 60));
  diff -= hours * (1000 * 60 * 60);

  const minutes = Math.floor(diff / (1000 * 60));
  diff -= minutes * (1000 * 60);

  const seconds = Math.floor(diff / 1000);

  // Update countdown state
  countdown.value = {
    days,
    hours,
    minutes,
    seconds,
  };
};

const startCountdown = () => {
  // Calculate immediately on start
  calculateTimeToFriday();

  // Then update every second
  onNuxtReady(() => {
    timerInterval = setInterval(() => {
      calculateTimeToFriday();
    }, 1000);
  });
};

const stopCountdown = () => {
  if (timerInterval) {
    clearInterval(timerInterval);
    timerInterval = null;
  }
};

// Lifecycle hooks
startCountdown();

onBeforeUnmount(() => {
  stopCountdown();
});
</script>

<style scoped>
.countdown-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.countdown-timer {
  color: #07f468;
  line-height: normal;
  font-size: 24px;
}
</style>
